/**
 * Utility to manage scrollbar behavior and prevent double scrollbars
 */

// Function to prevent the body from scrolling when a modal or specific container should scroll
export const preventBodyScroll = (shouldPrevent = true) => {
  if (shouldPrevent) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};

// Function to scroll to an element with improved smoothness
export const smoothScrollToElement = (element, offset = 0) => {
  if (!element) return;
  
  // Get the navbar height for proper offset calculation
  const navbar = document.querySelector('nav');
  const navbarHeight = navbar ? navbar.offsetHeight : 0;
  const totalOffset = navbarHeight + (offset || 0);
  
  // Calculate the target position
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - totalOffset;

  // Use requestAnimationFrame for smoother animation
  const duration = 800;
  const start = window.pageYOffset;
  const distance = offsetPosition - start;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);

    // Cubic easing out - acceleration until halfway, then deceleration
    const easing = 1 - Math.pow(1 - progress, 3);
    
    window.scrollTo(0, start + distance * easing);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      // Ensure we hit our target exactly
      window.scrollTo(0, offsetPosition);
    }
  }

  requestAnimationFrame(animation);
};

// Function to set up proper scrolling behavior
export const setupScrolling = () => {
  // Ensure only one scrollbar is shown
  document.documentElement.style.overflowY = 'auto';
  document.body.style.overflowY = 'hidden';
  
  // Enable smooth scrolling
  document.documentElement.style.scrollBehavior = 'smooth';
  
  // For touch devices, ensure smooth scrolling
  if ('ontouchstart' in window || navigator.maxTouchPoints) {
    document.documentElement.style.WebkitOverflowScrolling = 'touch';
  }
  
  return () => {
    // Cleanup function to reset when component unmounts
    document.documentElement.style.overflowY = '';
    document.body.style.overflowY = '';
    document.documentElement.style.scrollBehavior = '';
  };
};
